import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-enterprises-solutions",
  templateUrl: "./enterprises-solutions.component.html",
  styleUrls: ["./enterprises-solutions.component.scss"],
})
export class EnterprisesSolutionsComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    window.scrollTo(0, 0);
  }
}
